module.exports = __webpack_public_path__ + "static/img/img-home-jzg-02.340beaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-jzg-02.png
// module id = KeQn
// module chunks = 1